import type { ReactNode } from "react";

export function ExplainerPanel({
  summary,
  children,
  defaultOpen = false,
}: {
  summary: string;
  children: ReactNode;
  defaultOpen?: boolean;
}) {
  // A quiet one-liner; the full explanation opens underneath. Kept out of the way of the data.
  return (
    <details className="explain" open={defaultOpen}>
      <summary>ⓘ {summary.split(/ — | - /)[0]}</summary>
      <div className="explain-body">{children}</div>
    </details>
  );
}
